import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Container: ComponentStyleConfig = {
  baseStyle: {
    maxW: 'container.md',
  },
};

export default Container;
